export default __webpack_public_path__ + "static/media/s1_male.8548ba81.wav";